import type { PanelProps } from "../panel-props"

import { useDatabaseLength } from "../../../modules/database-length-store"
import { useSettings } from "../../../modules/settings"
import { Badge } from "../../badge"
import { SharedSettings } from "../shared-settings.tsx"

export function AppWithLocalIndexSettings(input: PanelProps) {
  const { index } = useSettings()
  const databaseLength = useDatabaseLength()
  return (
    <SharedSettings closeSidebar={input.closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Position</h3>
        <div>
          index <Badge value={String(index)} /> from{" "}
          <Badge value={String(databaseLength - 1)} />
        </div>
      </section>
    </SharedSettings>
  )
}
